export default __webpack_public_path__ + "static/injiri-0e62d3b4b1d9072b405030b4f3f53bc1.png";